import { Link } from 'react-router-dom';

const reasons = [
  {
    image: 'https://readdy.ai/api/search-image?query=Person%20relaxing%20on%20couch%20with%20laptop%20smiling%20while%20browsing%20products%20organized%20digital%20interface%20warm%20cozy%20living%20room%20setting%20soft%20ambient%20lighting%20effortless%20productivity%20modern%20lifestyle%20photography&width=400&height=300&seq=why-v2-save-time-2026&orientation=landscape',
    title: 'Save Hours Searching',
    desc: 'No more endless scrolling. Our kakobuy spreadsheet directory organizes thousands of products so you can find what you want in minutes.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20view%20on%20tablet%20screen%20showing%20two%20similar%20products%20with%20ratings%20and%20details%20clean%20desk%20setup%20with%20coffee%20cup%20modern%20workspace%20bright%20natural%20light%20organized%20professional%20environment&width=400&height=300&seq=why-v2-compare-2026&orientation=landscape',
    title: 'Compare Sellers Quickly',
    desc: 'Side-by-side seller comparisons help you evaluate ratings, prices, and reliability before making a purchase decision.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20holding%20magnifying%20glass%20over%20product%20details%20on%20screen%20checking%20quality%20information%20warm%20workspace%20with%20notebook%20soft%20natural%20light%20attention%20to%20detail%20professional%20review%20concept&width=400&height=300&seq=why-v2-quality-2026&orientation=landscape',
    title: 'Check Quality Before Ordering',
    desc: 'Access QC photos, detailed descriptions, and buyer reviews to verify product quality before you commit to an order.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Shield%20icon%20on%20phone%20screen%20with%20green%20checkmark%20symbolizing%20safe%20verified%20shopping%20clean%20minimal%20desk%20background%20with%20small%20plant%20soft%20daylight%20protection%20security%20concept%20modern%20tech%20lifestyle&width=400&height=300&seq=why-v2-avoid-2026&orientation=landscape',
    title: 'Avoid Unreliable Products',
    desc: 'Our safety guides and verified seller indicators help you steer clear of low-quality items and untrustworthy listings.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Excited%20person%20discovering%20new%20fashion%20items%20on%20laptop%20screen%20with%20trending%20product%20grid%20displayed%20bright%20airy%20room%20with%20houseplants%20genuine%20happy%20expression%20lifestyle%20authentic%20moment%20modern%20interior&width=400&height=300&seq=why-v2-discover-2026&orientation=landscape',
    title: 'Discover Trending Finds',
    desc: 'Stay ahead of the curve with daily updates on the hottest products and emerging trends across all categories.',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Friendly%20step%20by%20step%20guide%20displayed%20on%20tablet%20with%20illustrated%20instructions%20warm%20inviting%20home%20setting%20with%20throw%20blanket%20and%20warm%20beverage%20approachable%20learning%20atmosphere%20cozy%20modern%20lifestyle%20photography&width=400&height=300&seq=why-v2-beginner-2026&orientation=landscape',
    title: 'Beginner Friendly Experience',
    desc: 'Complete guides walk you through every step of using kakobuy spreadsheet, from first-time browsing to placing your order.',
  },
];

export default function WhyBuyersSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 tracking-tight">
            Why Do Buyers Use Kakobuy Spreadsheet?
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Thousands of savvy shoppers rely on our directory every day. Here is why the kakobuy spreadsheet has become the go-to resource for informed buyers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((reason, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Card image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={reason.image}
                  alt={reason.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Card text */}
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                  {reason.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/guides/how-to-use-kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors"
          >
            <span>Learn more in our complete guide</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}